import axios from 'axios';

let prefix = '/mail';

const MailApi = {
	getMailList(payload) {
		return axios.get(prefix + '/list', { params: payload });
	},
	getMail(id) {
		return axios.get(prefix + `/get/${id}`);
	},
	createMail(payload) {
		return axios.post(prefix + '/create', payload);
	},
	updateMail(payload) {
		return axios.post(prefix + '/update', payload);
	},
	deleteMail(payload) {
		return axios.delete(prefix + '/delete', { params: payload });
	},
	sendMail(payload) {
		return axios.post(prefix + '/send', payload);
	},
};

export default MailApi;
